// src/pages/Swap/components/SwapSettings.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { feeConfig } from '../../../config/feeConfig';
import { isUsingSushiSwap } from '../../../services/sushiswapApi';

/**
 * SwapSettings component displays swap settings summary
 */
const SwapSettings = ({ 
  slippage, 
  aggregatorFeePercentage, // This will be replaced with our new fee calculation
  collectFeesInWeth,
  deadline,
  showSummary
}) => {
  const { t } = useTranslation();
  
  // Only show settings if we have tokens selected
  if (!showSummary) return null;

  // Calculate the fee to display
  const displayFee = isUsingSushiSwap ? 
    (feeConfig.enabled ? feeConfig.swapFeePercentage / 100 : 0) : 
    aggregatorFeePercentage;

  // Determine fee collection method for display
  const feeCollectionMethod = isUsingSushiSwap ? 
    '' :
    (collectFeesInWeth ? ` (${t('swap.settings.inWETH')})` : '');

  return (
    <div className="swap-settings-summary">
      <div className="setting-item">
        <span>{t('swap.settings.slippageTolerance')}</span>
        <span>{slippage}%</span>
      </div>
      <div className="setting-item">
        <span>{t('swap.settings.transactionDeadline')}</span>
        <span>{deadline} {t('swap.settings.minutes')}</span>
      </div>
      {/*
      <div className="setting-item">
        <span>{t('swap.settings.bitdogSwapFee')}</span>
        <span>{displayFee.toFixed(1)}%{feeCollectionMethod}</span>
      </div> */}
      <div className="setting-item">
        <span>{t('swap.settings.dexFee')}</span>
        <span>0.3%</span>
      </div>
    </div>
  );
};

export default SwapSettings;